"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._EncryptionConfiguration = {
    type: "structure",
    required: [],
    members: {
        ReplicaKmsKeyID: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_EncryptionConfiguration.js.map